import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { ShareContent } from '@module/assignment-components';
import { Avatar, Modal, Space } from 'antd';
import styled from '@xstyled/styled-components';
import { buildAssignmentShareUrl } from '../../../utils/assignment-url.util';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTitleSuccess = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 20px;\n  margin-left: 11px;\n  align-items: center;\n"])));
var StyledModalWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  .ant-modal-content {\n    border-radius: 16px;\n  }\n"])));
export var onShowAssignmentCreationSuccessModal = function onShowAssignmentCreationSuccessModal(_ref) {
  var assignmentInfo = _ref.assignmentInfo,
      assignmentCreationBasicInfo = _ref.assignmentCreationBasicInfo,
      assignmentCreationType = _ref.assignmentCreationType,
      assignmentCreationModalSharing = _ref.assignmentCreationModalSharing;
  var shareUrl = buildAssignmentShareUrl(assignmentInfo.id.toString(), assignmentInfo.title);
  Modal.info({
    icon: /*#__PURE__*/_jsxs(Space, {
      children: [/*#__PURE__*/_jsx(Avatar, {
        src: "/images/icons/icon-check-circle.png",
        size: "large"
      }), /*#__PURE__*/_jsx(StyledTitleSuccess, {
        children: assignmentInfo.title
      })]
    }),
    content: /*#__PURE__*/_jsx(ShareContent, {
      assignmentId: assignmentInfo.id.toString(),
      idNumber: assignmentInfo.idNumber,
      sharedLink: shareUrl,
      absoluteShareUrl: shareUrl,
      linkSectionLabel: assignmentCreationModalSharing.shareAssignmentNow,
      shareAssignmentTranslation: assignmentCreationModalSharing
    }),
    modalRender: function modalRender(node) {
      return /*#__PURE__*/_jsx(StyledModalWrapper, {
        children: node
      });
    }
  });
};